export default __webpack_public_path__ + "static/media/Trust.96f734fc.png";